import React from 'react';
import { DialogHeader, DialogMain } from '../../../shared/components/dialog';
import { useDialogContext } from '../../../shared/components/dialog/DialogContext';
import { DialogFooter } from '../../../shared/components/dialog/DialogFooter';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { AuthFormActions } from '../../shared/form-layout/AuthFormActions';
import { useDeleteAccount } from '../hooks/useDeleteAccount';
import { ArrowButton, AsyncDataPlaceholder, TextButton } from '../../../../ui';

export const DeleteAccountDialogContent = () => {
	const { t } = useTranslation();
	const { close } = useDialogContext();
	const { onDeleteAccount, isLoading, error } = useDeleteAccount();

	return (
		<>
			<DialogHeader title={t('user_delete_account_label')} />

			<DialogMain>
				<p>{t('user_delete_account_dialog_message')}</p>
				<AuthFormActions>
					<ArrowButton onClick={onDeleteAccount} disabled={isLoading}>
						{t('form_sure_confirm_button_label')}
					</ArrowButton>
					<TextButton onClick={close} variant="highlight">
						{t('form_cancel_button_label')}
					</TextButton>
				</AuthFormActions>
			</DialogMain>
			{isLoading && <AsyncDataPlaceholder />}
			{error && (
				<DialogFooter variation="error">
					{t('user_delete_account_failed_message')}
				</DialogFooter>
			)}
		</>
	);
};
